import React from "react";
import {
  TextField,
  Box,
  Typography,
  Button,
  IconButton,
  Paper,
  Divider,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { Formik, Form, FieldArray } from "formik";
import * as Yup from "yup";
import { uploadImage } from "services/imageUpload";
import { IMAGE_URL } from "network";
import { useUploadBeauticianDocMutation } from "slices/beautyApp/beauticianSlice";
import Swal from "sweetalert2";

function Step2({ val, onNext }) {
  const [uploadDoc] = useUploadBeauticianDocMutation();
  const validationSchema = Yup.object().shape({
    documents: Yup.array().of(
      Yup.object().shape({
        keyName: Yup.string().required("Document name is required"),
        keyValue: Yup.mixed().required("File is required"),
      }),
    ),
  });

  const initialValues = {
    documents: [
      {
        keyName: "",
        keyValue: "",
      },
    ],
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={async (values, { setSubmitting }) => {
        let response = await uploadDoc({ body: values.documents, id: val._id });
        if (response?.data) {
          onNext();
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response?.message,
          });
        }
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        setFieldValue,
        isSubmitting,
      }) => (
        <Form>
          <Box className="container py-4">
            <Typography variant="h5" gutterBottom>
              Upload Documents (Images Only)
            </Typography>

            <FieldArray name="documents">
              {({ push, remove }) => (
                <>
                  {values.documents.map((doc, index) => (
                    <Paper
                      key={index}
                      elevation={3}
                      sx={{
                        padding: 2,
                        marginBottom: 3,
                        borderRadius: 2,
                        position: "relative",
                      }}
                    >
                      <Box
                        display="flex"
                        alignItems="center"
                        gap={2}
                        flexWrap="wrap"
                      >
                        <TextField
                          fullWidth
                          label="Document Name"
                          name={`documents.${index}.keyName`}
                          value={doc.keyName}
                          onChange={handleChange}
                          error={
                            touched.documents?.[index]?.keyName &&
                            Boolean(errors.documents?.[index]?.keyName)
                          }
                          helperText={
                            touched.documents?.[index]?.keyName &&
                            errors.documents?.[index]?.keyName
                          }
                          sx={{ marginBottom: 2 }}
                        />
                        {values.documents.length > 1 && (
                          <IconButton
                            onClick={() => remove(index)}
                            sx={{ position: "absolute", top: 8, right: 8 }}
                            color="error"
                          >
                            <DeleteIcon />
                          </IconButton>
                        )}

                        <Button variant="contained" component="label">
                          Upload Image
                          <input
                            type="file"
                            accept="image/*"
                            hidden
                            onChange={async (e) => {
                              const file = e.currentTarget.files[0];
                              if (file) {
                                // setFieldValue(`documents.${index}.file`, file);
                                const response = await uploadImage(file);
                                setFieldValue(
                                  `documents.${index}.keyValue`,
                                  response,
                                );
                                // setFieldValue(
                                //   `documents.${index}.preview`,
                                //   response
                                // );
                              }
                            }}
                          />
                        </Button>

                        {touched.documents?.[index]?.keyValue &&
                          errors.documents?.[index]?.keyValue && (
                            <Typography
                              variant="body2"
                              color="error"
                              sx={{ marginTop: 1 }}
                            >
                              {errors.documents[index].keyValue}
                            </Typography>
                          )}

                        {doc.keyValue && (
                          <Box>
                            <img
                              crossOrigin="anonymous"
                              src={IMAGE_URL + doc.keyValue}
                              alt="Preview"
                              style={{
                                height: 100,
                                width: "auto",
                                marginTop: 8,
                                borderRadius: 4,
                                border: "1px solid #ccc",
                                padding: 4,
                              }}
                            />
                          </Box>
                        )}
                      </Box>
                    </Paper>
                  ))}

                  <Button
                    variant="outlined"
                    startIcon={<AddIcon />}
                    onClick={() =>
                      push({
                        keyName: "",
                        keyValue: "",
                      })
                    }
                  >
                    Add More
                  </Button>
                </>
              )}
            </FieldArray>

            <Box display="flex" justifyContent="flex-end" mt={4}>
              <Button type="submit" variant="contained" disabled={isSubmitting}>
                Next
              </Button>
            </Box>
          </Box>
        </Form>
      )}
    </Formik>
  );
}

export default Step2;
